// extracted by mini-css-extract-plugin
export var aboveInput = "_nm-0";
export var actionButton = "_nm-5";
export var actionButtonContainer = "_nm-1";
export var actionIcon = "_nm-6";
export var aiInfoContainer = "_nm-2";
export var attachmentWrapper = "_nm-7";
export var bold = "_nm-3";
export var checkIcon = "_nm-8";
export var clickingRecipientBar = "_nm-11";
export var commentThreadSwitch = "_nm-a";
export var draftImage = "_nm-b";
export var draftImageContainer = "_nm-c";
export var draftImages = "_nm-e";
export var editButton = "_nm-g";
export var editor = "_nm-f";
export var editorContainer = "_nm-y";
export var editorErrorTooltipWrapper = "_nm-9";
export var headerDivider = "_nm-h";
export var icon = "_nm-i";
export var info = "_nm-j";
export var internal = "_nm-n";
export var internalDivider = "_nm-k";
export var internalMessage = "_nm-l";
export var messageInputCard = "_nm-m";
export var messageInputForm = "_nm-o";
export var messageInputFormInternal = "_nm-p";
export var options = "_nm-q";
export var publicMessageCustomer = "_nm-s";
export var publicMessageMerchant = "_nm-r";
export var removeImageButton = "_nm-d";
export var replyButtons = "_nm-t";
export var showSignatureButton = "_nm-u";
export var spinner = "_nm-v";
export var verticalButtonDivider = "_nm-4";
export var visibilitySelector = "_nm-w";
export var warning = "_nm-x";
export var wrappingText = "_nm-z";
export var writingInternalNoteTopBorder = "_nm-10";